import { FocusBody } from '@components/FocusBody'
import { FocusLayout } from '@components/FocusLayout'

const routes = [
  {
    path: '/status',
    component: FocusLayout,
    children: [
      {
        path: '/on-hold',
        component: () => <FocusBody title="Action Required" text="We’ve paused your access because we ran into an issue securing your payment. Don't worry, your data is safe! You can unlock your account immediately by completing the payment below." />,
      },
      {
        path: '/cancelled',
        component: () => <FocusBody title="Subscription Inactive" text="Your subscription has been cancelled, so you no longer have access to these features. Ready to come back? Reactivating your account takes just a few seconds." />,
      },
      {
        path: '/expired',
        component: () => <FocusBody title="Subscription Expired" text="Your subscription has expired, so you no longer have access to these features. Reactivating your account takes just a few seconds." />,
      },
      {
        path: '/past-due',
        component: () => <FocusBody title="We couldn't process your payment" text="It looks like there was a hiccup with your payment method (it may be expired or declined). Please update your billing details to jump right back in." />,
      },
      {
        path: '/subscribe',
        component: () => <FocusBody title="We hope you enjoyed your first year" text="Please change to a subscription plan to continue your journey." />,
      },
    ],
  },
]

export default routes
